module.exports = __webpack_public_path__ + "img/loader.a4a78305.gif";